var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"text-center border border-danger"},[_c('b',[_vm._v("Bespoke reports do not come with this content.")]),_vm._v(" "),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }